"use client";

import SessionStorage from "@casino/client/utils/storage/SessionStorage";
import { useGamePageData } from "@casino/ui/Games/hooks";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  useMediaQuery,
} from "@workspace/frontend-ui";
import type { FC } from "react";
import { useState } from "react";
import RotateScreenIcon from "./RotateScreenIcon";

type Props = {
  category?: string;
};

const DISMISSED_STORAGE_KEY = "rotate-screen-modal-dismissed";
const MOBILE_MEDIA_QUERY = "(max-width: 767px)";

const RotateScreenModal: FC<Props> = ({ category }) => {
  const isPortrait = useMediaQuery("(orientation: portrait)");
  // Portrait alone also matches a narrow desktop window; this prompt is meant for a phone.
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
  const [isDismissed, setDismissed] = useState(
    () => !!SessionStorage.getItem(DISMISSED_STORAGE_KEY),
  );
  const { t } = useGamePageData();

  const isLiveCategory = !!category?.toLowerCase().includes("live");
  const isOpen = isLiveCategory && isMobile && isPortrait && !isDismissed;

  const handleOpenChange = () => {
    setDismissed(true);
    SessionStorage.setItem(DISMISSED_STORAGE_KEY, true);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="bg-background">
        <RotateScreenIcon />
        <DialogTitle className="text-center">
          {t("game.rotate.title", "Rotate your phone")}
        </DialogTitle>
        <DialogDescription className="text-center">
          {t(
            "game.rotate.description",
            "For the best experience, rotate your phone to landscape mode and go fullscreen.",
          )}
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
};

export default RotateScreenModal;
